<template>
  <div class="templates-wrapper" ref="homeWrapper">
    <Banner2
      id="Banner1_0"
      :is-mobile="isMobile"
    />
    <Content7
      id="Content7_0"
      :is-mobile="isMobile"
    />
    <Content6
      id="Content6_0"
      :is-mobile="isMobile"
    />
    <!-- <Content5
      id="Content5_0"
      :is-mobile="isMobile"
    /> -->
    <Content4
      id="Content4_0"
      :is-mobile="isMobile"
    />
    <!-- <Content8
      id="Content8_0"
      :is-mobile="isMobile"
    /> -->
  </div>
</template>

<script>
import Banner2 from './Banner2.vue'
import Content7 from './Content7.vue'
import Content6 from './Content6.vue'
// import Content5 from './Content5.vue'
import Content4 from './Content4.vue'
// import Content8 from './Content8.vue'

export default {
  name: 'HomeView',
  components: {
    Banner2,
    Content7,
    Content6,
    // Content5,
    Content4,
    // Content8
  },
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    // 适配手机屏幕
    this.enquireScreen(b => {
      this.isMobile = !!b
    })
  },
  methods: {
    enquireScreen(cb) {
      const mediaQuery = window.matchMedia('(max-width: 768px)')
      cb(mediaQuery.matches)
      mediaQuery.addListener(mq => cb(mq.matches))
    }
  }
}
</script>

<style scoped>
.templates-wrapper {
  width: 100%;
  min-height: 100vh;
}
</style>